import { useState, useEffect } from 'react';
import { mockDashboardData } from '../data/mockData';

export const useDashboardData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 500));
        setData(mockDashboardData);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const refreshData = async () => {
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 300));

    const updatedData = {
      ...mockDashboardData,
      metrics: {
        ...mockDashboardData.metrics,
        verificationsToday: mockDashboardData.metrics.verificationsToday + Math.floor(Math.random() * 5),
        newUsersToday: mockDashboardData.metrics.newUsersToday + Math.floor(Math.random() * 3)
      }
    };

    setData(updatedData);
    setLoading(false);
  };

  return {
    data,
    loading,
    error,
    refreshData
  };
};